import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarComponent } from './calendar.component';
import { CalendarModule as PrimeCalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeCalendarModule,
  ],
  declarations: [
    CalendarComponent,
  ],
  exports: [
    CalendarComponent,
  ]
})
export class CalendarModule { }
